import React, { useState } from 'react';

const MainCard = ({ children, gap, width, maxHeight }) => {
  const widthClass = width ? `md:w-[${width}px]` : 'md:w-[650px]';
  const maxHeightClass = maxHeight ? `max-h-[${maxHeight}px]` : 'max-h-[600px]';
  

  return (
    <div className={`w-full flex justify-center items-center max-h-[625px] p-2`}>
      <div className={`${widthClass} w-[375px] ${maxHeightClass} md:max-h-[750px] overflow-y-auto p-2 md:pt-6 md:px-6 mt-3 bg-white rounded-lg shadow-[rgba(0,0,0,.5)_-2px_2px_10px_-5px] flex-col items-center gap-${gap} flex`}>
          {children}
      </div>
    </div>
  );
};

MainCard.defaultProps = {
  gap: 5, // Set the default gap value here
  width: null,
  maxHeight: null,
};

export default MainCard;